<template>
  <el-container style="padding:20px">
    <div class="mainBox">
      <div class="toolbar" style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px">
        <div style="display:flex;align-items:center;gap:12px">
          <h3 style="margin:0">后台管理员</h3>
          <el-input v-model="filters.keyword" placeholder="按用户名搜索" clearable @clear="onSearchClear" @keyup.enter.native="onSearch" style="width:240px"/>
          <el-button @click="onSearch">搜索</el-button>
          <el-button @click="onRefresh">刷新</el-button>
        </div>
        <div>
          <el-button type="primary" @click="onCreate">新增管理员</el-button>
        </div>
      </div>
  
      <el-table :data="pagedList" style="width:100%">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="username" label="用户名" />
        <el-table-column prop="role" label="角色" width="120" />
        <el-table-column label="操作" width="220">
          <template #default="{ row }">
            <el-button size="small" @click="onEdit(row)">编辑</el-button>
            <el-button size="small" type="danger" @click="onDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <div style="margin-top:12px;text-align:right">
        <el-pagination
          background
          :page-size="pageSize"
          :current-page.sync="currentPage"
          :total="total"
          layout="prev, pager, next, sizes, total"
          :page-sizes="[10,20,50]"
          @size-change="onPageSizeChange"
          @current-change="onPageChange"
        />
      </div>

    </div>


    <el-dialog title="编辑管理员" v-model="showDialog">
      <el-form :model="form">
        <el-form-item label="用户名">
          <el-input v-model="form.username" />
        </el-form-item>
        <el-form-item label="密码（留空表示不修改）">
          <el-input v-model="form.password" type="password" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </template>
    </el-dialog>
  </el-container>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import { admins } from '../api'
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  setup () {
    const list = ref([])
    const showDialog = ref(false)
    const form = ref({})
    const currentPage = ref(1)
    const pageSize = ref(10)
    const total = ref(0)

    const pagedList = computed(() => {
      const filtered = list.value.filter(item => {
        if (!filters.keyword) return true
        const k = filters.keyword.toString().toLowerCase()
        return (item.username && item.username.toLowerCase().includes(k))
      })
      total.value = filtered.length
      const start = (currentPage.value - 1) * pageSize.value
      return filtered.slice(start, start + pageSize.value)
    })

    const filters = ref({ keyword: '' })

    const load = async () => {
      const res = await admins.list()
      const rows = (res.data && res.data.data) ? res.data.data : (res.data || [])
      list.value = Array.isArray(rows) ? rows : []
      if ((currentPage.value -1) * pageSize.value >= list.value.length) currentPage.value = 1
    }

    const onCreate = () => {
      form.value = { username: '', password: '' }
      showDialog.value = true
    }

    const onSearch = () => { currentPage.value = 1 }
    const onSearchClear = () => { filters.value.keyword = ''; onSearch() }
    const onRefresh = () => { load() }

    const onEdit = (row) => {
      form.value = { ...row, password: '' }
      showDialog.value = true
    }

    const save = async () => {
      try {
        if (form.value.id) {
          const res = await admins.update(form.value.id, form.value)
          const ok = !(res.data && res.data.code && res.data.code !== 200)
          if (!ok) throw new Error(res.data.message || '更新失败')
          ElMessage.success('已更新')
        } else {
          // ensure role default
          const payload = { username: form.value.username, password: form.value.password, role: form.value.role || 'admin' }
          const res = await admins.create(payload)
          const ok = !(res.data && res.data.code && res.data.code !== 200)
          if (!ok) throw new Error(res.data.message || '创建失败')
          ElMessage.success('已创建')
        }
        showDialog.value = false
        await load()
      } catch (err) {
        console.error(err)
        ElMessage.error(err?.response?.data?.message || err.message || '保存失败')
      }
    }

    const onDelete = async (row) => {
      try {
        await ElMessageBox.confirm('确认删除该管理员吗？', '删除', { type: 'warning' })
        await admins.remove(row.id)
        ElMessage.success('已删除')
        load()
      } catch (err) {}
    }

    onMounted(load)
    const onPageChange = (page) => { currentPage.value = page }
    const onPageSizeChange = (size) => { pageSize.value = size; currentPage.value = 1 }

    return { list, pagedList, showDialog, form, onCreate, onEdit, save, onDelete, currentPage, pageSize, total, onPageChange, onPageSizeChange, filters, onSearch, onSearchClear, onRefresh }
  }
}
</script>

<style scoped>
.mainBox {
  width:100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap : 12px;
}
</style>